import { Injectable } from "@angular/core";
import * as moment from "moment";
import { ScheduleServiceInterval } from "src/app/models/ScheduleServiceInterval";

import LocalizationConstants from "../constants/localization-constants";

@Injectable({
  providedIn: "root",
})
export class ScheduleService {
  constructor() {}

  intervals: ScheduleServiceInterval[] = [
    {
      id: "DAYS",
      title: "Days",
      localizedTitle: LocalizationConstants.INTERVALS_DAYS,
    },
    {
      id: "MONTHS",
      title: "Months",
      localizedTitle: LocalizationConstants.INTERVALS_MONTHS,
    },
    {
      id: "YEARS",
      title: "Years",
      localizedTitle: LocalizationConstants.INTERVALS_YEARS,
    },
  ];

  calibrationStatuses = [
    { id: "1", title: "OK" },
    { id: "2", title: "Still OK" },
    { id: "3", title: "Not OK" },
    { id: "4", title: "None" },
  ];

  getFrequencyList(interval) {
    if (interval === "MONTHS") return Array.from({ length: 12 }, (_, i) => i + 1);
    if (interval === "DAYS") return Array.from({ length: 31 }, (_, i) => i + 1);
    if (interval === "YEARS") return Array.from({ length: 5 }, (_, i) => i + 1);
  }

  getNextScheduleDate(interval: string, frequency: number, lastDate: Date) {
    if (!lastDate) lastDate = new Date();
    let nextDate = new Date();
    switch (interval) {
      case "DAYS":
        nextDate = moment.utc(lastDate).add(frequency, "d").toDate();
        break;
      case "MONTHS":
        nextDate = moment.utc(lastDate).add(frequency, "M").toDate();
        break;
      case "YEARS":
        nextDate = moment.utc(lastDate).add(frequency, "y").toDate();
        break;
    }

    return nextDate;
  }
}
